import Image, { StaticImageData } from 'next/image';

import { H2, H3, H5 } from '@common/headline';
import { Services } from './Services';

import NHSPartner from '@public/img/nhs/nhs-partner.png';
import UKInsurer from '@public/img/nhs/uk-insurer-partner.png';
import vitality from '@public/img/nhs/vitality.png';
import nhs from '@public/img/nhs/nhs.png';
import dhl from '@public/img/nhs/dhl.png';
import nhsScotland from '@public/img/nhs/nhs-scotland.png';
import reed from '@public/img/nhs/reed.png';

const PartnerBlock = ({
  image,
  title,
  body,
}: {
  image: StaticImageData;
  title: string;
  body: string;
}): JSX.Element => (
  <div className="flex h-full max-w-lg flex-col overflow-hidden rounded-3xl bg-white text-left drop-shadow-[0_20px_40px_rgba(9,37,48,0.07)] transition duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg md:max-w-xl lg:max-w-none">
    <Image src={image} alt="Partner" />
    <div className="flex grow flex-col justify-between p-6">
      <div>
        <H3>{title}</H3>
        <H5>{body}</H5>
      </div>
    </div>
  </div>
);

export const PartnersAndServices = (): JSX.Element => (
  <div className="relative w-full bg-dawn-blue-100 px-8 py-16 text-center text-blue lg:px-16 lg:py-28">
    <div className="m-auto max-w-[1440px]">
      <H2>Partners and services</H2>
      <div className="grid grid-cols-1 gap-6 py-10 lg:grid-cols-2 lg:py-20">
        <div className="mx-auto">
          <PartnerBlock
            image={NHSPartner}
            title="NHS"
            body="We've supported over 100,000 NHS patients through our weight management, diabetes prevention, and diabetes management services"
          />
        </div>
        <div className="mx-auto">
          <PartnerBlock
            image={UKInsurer}
            title="Health insurers and employers"
            body="We support tens of thousands of insurance clients and employees with a benefit that makes a significant difference to their health goals"
          />
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-6 text-center lg:gap-16">
        <Image src={vitality} alt="Healthier You" height={73} width={99} />
        <Image src={nhs} alt="London Partners" height={73} width={93} />
        <Image src={dhl} alt="Digital Health London" height={73} width={239} />
        <Image
          src={nhsScotland}
          alt="Digital Health London"
          height={73}
          width={69}
        />
        <Image src={reed} alt="Digital Health London" height={73} width={73} />
      </div>
      <Services />
    </div>
  </div>
);
